import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FadeUp } from "./Motion";

export const CtaBand = ({ title = "Got feedback, a question or an idea?", text = "We read every message that lands in our inbox." }) => (
  <section className="px-5 py-20 sm:px-8 sm:py-28">
    <FadeUp className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-[#0D6EFD] px-8 py-16 text-white sm:px-16 sm:py-20">
      <div className="absolute -bottom-24 -right-10 h-80 w-80 rounded-full border-[40px] border-white/10" />
      <div className="absolute -top-20 right-40 h-40 w-40 rounded-full bg-white/10 blur-2xl" />
      <h2 className="font-display relative max-w-2xl text-4xl font-extrabold leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">{title}</h2>
      <p className="relative mt-5 max-w-lg text-base text-blue-50 md:text-lg">{text}</p>
      <Link to="/contact" data-testid="cta-band-contact-button" className="group relative mt-9 inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-bold text-[#0B132B] transition-transform duration-300 hover:-translate-y-1">
        Contact us <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
      </Link>
    </FadeUp>
  </section>
);
